document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.unique-reels-section');

  sections.forEach(section => {
    const slides = section.querySelectorAll('.main-reel-slide');
    const navItems = section.querySelectorAll('.reel-nav-item');
    const prevBtns = section.querySelectorAll('.prev-arrow');
    const nextBtns = section.querySelectorAll('.next-arrow');
    const innerWrappers = section.querySelectorAll('.video-wrapper-inner');
    const closeBtn = section.querySelector('.lightbox-close-trigger');
    const muteBtn = section.querySelector('.custom-mute-btn');
    
    let currentIndex = 0;
    let isGlobalMuted = true;
    let lastScrollTime = 0;

    function switchReel(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      // Reset all active video slides
      slides.forEach(slide => {
        slide.classList.remove('active', 'paused');
        const video = slide.querySelector('video');
        if (video) video.pause();
      });

      // Update active thumbnail item border highlight
      navItems.forEach(item => item.classList.remove('active'));
      if (navItems[index]) {
        navItems[index].classList.add('active');
      }

      currentIndex = index;
      const activeSlide = slides[currentIndex];
      if (activeSlide) {
        activeSlide.classList.add('active');
        const activeVideo = activeSlide.querySelector('video');
        if (activeVideo) {
          activeVideo.muted = isGlobalMuted;
          activeVideo.currentTime = 0;
          activeVideo.play().catch(() => {});
        }
      }
    }

    // WORKABLE FIX: Clicking thumbnail stack items changes the active video reel
    navItems.forEach((item, idx) => {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        switchReel(idx);
      });
    });

    // Opens custom fullscreen layout or plays/pauses on card screen click
    innerWrappers.forEach((wrapper, idx) => {
      wrapper.addEventListener('click', function(e) {
        if (!document.body.classList.contains('reels-lightbox-active')) {
          document.body.classList.add('reels-lightbox-active');
          switchReel(idx);
        } else {
          const video = wrapper.querySelector('video');
          const slide = slides[idx];
          if (video.paused) {
            video.play();
            slide.classList.remove('paused');
          } else {
            video.pause();
            slide.classList.add('paused');
          }
        }
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        document.body.classList.remove('reels-lightbox-active');
        switchReel(currentIndex);
      });
    }

    // Scroll Navigation Control System
    window.addEventListener('wheel', function(e) {
      if (!document.body.classList.contains('reels-lightbox-active')) return;
      const currentTime = new Date().getTime();
      if (currentTime - lastScrollTime < 800) return;

      if (e.deltaY > 0) switchReel(currentIndex + 1);
      else if (e.deltaY < 0) switchReel(currentIndex - 1);
      lastScrollTime = currentTime;
    }, { passive: true });

    // Pill Navigation buttons
    nextBtns.forEach(btn => btn.addEventListener('click', (e) => { e.stopPropagation(); switchReel(currentIndex + 1); }));
    prevBtns.forEach(btn => btn.addEventListener('click', (e) => { e.stopPropagation(); switchReel(currentIndex - 1); }));

    // Shared Sound Controller Mute Toggle Actions
    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        isGlobalMuted = !isGlobalMuted;
        slides.forEach(slide => {
          const vid = slide.querySelector('video');
          if (vid) vid.muted = isGlobalMuted;
        });

        if (isGlobalMuted) {
          muteBtn.innerHTML = `<svg fill="currentColor" viewBox="0 0 24 24" width="16" height="16"><path d="M4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>`;
        } else {
          muteBtn.innerHTML = `<svg fill="currentColor" viewBox="0 0 24 24" width="16" height="16"><path d="M5 17h3l5 5V2l-5 5H5v10zm14-5c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/></svg>`;
        }
      });
    }
  });
});